module.exports = {"APP_NAME":"wynk_web","About":"A propos","Hello world !":"Bonjour le monde !","Home":"Accueil","Logged in as":"Connecté en tant que","Login":"Connexion","Logout":"Déconnexion","Password":"Mot de passe","Password is required":"Mot de passe requis","Username":"Identifiant","Username is required":"Identifiant requis","Username or password incorrect.":"Identifiant ou mot de passe incorrect.","Remember me":"Rester connecté","Version":"Version"}


//////////////////
// WEBPACK FOOTER
// d:/workspace/wynk_web_shoppings_3_prod/src/translations/fr-FR.json
// module id = ../../../../../src/translations/fr-FR.json
// module chunks = main